import { BranchsActionsInterface } from "../interfaces/branchsInterface";

export const OWNER = {
    BRANCHS: "OWNER/BRANCHS",
    CLEAR: "OWNER/CLEAR"
}

const initialState = {
    branchs: []
};

export default function (state = initialState, action: BranchsActionsInterface){
    switch(action.type){
        case OWNER.BRANCHS: {
            return {
                ...state,
                branchs: action.payload
            }
        }

        case OWNER.CLEAR: {
            return initialState
        }
        
        default: return state;
    }
}